import {FC} from 'react';
//mui
import {Box, Link, Typography} from '@mui/material';
//icons
import {ReactComponent as LogoIcon} from '@icons/logo-text-white.svg';
import {ReactComponent as LoginBackgroundIcon} from '@icons/login-background.svg';
//constants
import {BODY1, BODY2, H5} from '@/utils/constants';
//enums
import {ROUTER_URL} from '@/utils/enums';
//styles
import {asideInfoStyle} from './AsideInfo.styles';

const AsideInfo: FC = () => {
  return (
    <Box sx={asideInfoStyle.wrapper}>
      <Box sx={asideInfoStyle.logo}>
        <LogoIcon />
      </Box>

      <Box sx={asideInfoStyle.backgroundIcon}>
        <LoginBackgroundIcon />
      </Box>

      <Box sx={asideInfoStyle.centerContent}>
        <Typography sx={asideInfoStyle.title} variant={H5}>
          Powerfully Simple
          <br />
          Every Detail. Made Easy.
        </Typography>
        <Typography sx={asideInfoStyle.description} variant={BODY1}>
          From set up to the last acknowledgment, and all the guest management and bidding in between, Event Simpli
          makes it easy. Launch an event in minutes…and for free!
        </Typography>
      </Box>

      <Box sx={asideInfoStyle.footer}>
        <Typography sx={asideInfoStyle.link} variant={BODY2}>
          EventSimpli © 2023
        </Typography>
        <Link sx={asideInfoStyle.link} variant={BODY2} href={ROUTER_URL.ORGANIZATION_PRIVACY_POLICY}>
          Privacy Policy
        </Link>
        <Link sx={asideInfoStyle.link} variant={BODY2} href={ROUTER_URL.ORGANIZATION_TERMS_AND_CONDITIONS}>
          Terms & Conditions
        </Link>
      </Box>
    </Box>
  );
};

export default AsideInfo;
